"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBrandMerchantsResponseAllOfToJSON = exports.GetBrandMerchantsResponseAllOfFromJSONTyped = exports.GetBrandMerchantsResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetBrandMerchantsResponseAllOfFromJSON(json) {
    return GetBrandMerchantsResponseAllOfFromJSONTyped(json, false);
}
exports.GetBrandMerchantsResponseAllOfFromJSON = GetBrandMerchantsResponseAllOfFromJSON;
function GetBrandMerchantsResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'brandMerchants': (json['brandMerchants'].map(_1.BrandToMerchantPermissionsFromJSON)),
    };
}
exports.GetBrandMerchantsResponseAllOfFromJSONTyped = GetBrandMerchantsResponseAllOfFromJSONTyped;
function GetBrandMerchantsResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'brandMerchants': (value.brandMerchants.map(_1.BrandToMerchantPermissionsToJSON)),
    };
}
exports.GetBrandMerchantsResponseAllOfToJSON = GetBrandMerchantsResponseAllOfToJSON;
